import { type SpotQuoteRepository } from '../infra/SpotQuoteRepository'
import { getBookNowStatus } from './getBookNowStatus'

export type BookNowSpotQuoteFactoryDependencies = {
  spotQuoteRepository: SpotQuoteRepository
}

type PollResult = {
  shipmentLink?: string | null
}

export async function pollBookNowStatus(uuid: string, draftQuoteId: string): Promise<PollResult> {
  let pollingAttempts = 0
  let timer: NodeJS.Timeout
  const maxAttempts = 15

  return new Promise((resolve, reject) => {
    async function updateBookNowStatus() {
      try {
        const { items } = await getBookNowStatus(uuid)
        const bookedNowItem = items.find(item => item.rate === draftQuoteId)
        const bookNowRateStatus = bookedNowItem?.status

        if (bookNowRateStatus === 'booked') {
          clearTimeout(timer)
          resolve({ shipmentLink: bookedNowItem?.shipmentLink })
          return
        }
        if (bookNowRateStatus === 'failed') {
          clearTimeout(timer)
          reject(new Error('Book now failed'))
          return
        }

        pollingAttempts += 1

        if (pollingAttempts > maxAttempts) {
          clearTimeout(timer)
          reject(new Error('Max polling attempts exceeded'))
        }

        timer = setTimeout(() => {
          updateBookNowStatus()
        }, 1000)
      } catch (error) {
        clearTimeout(timer)
        reject(error)
      }
    }

    updateBookNowStatus()
  })
}
